import { render, staticRenderFns } from "./ClassRoom.vue?vue&type=template&id=56d89384&scoped=true"
import script from "./ClassRoom.vue?vue&type=script&lang=js"
export * from "./ClassRoom.vue?vue&type=script&lang=js"
import style0 from "./ClassRoom.vue?vue&type=style&index=0&id=56d89384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d89384",
  null
  
)

export default component.exports